import { render, staticRenderFns } from "./ModalSelectDoctors.vue?vue&type=template&id=4b86de72&scoped=true"
import script from "./ModalSelectDoctors.vue?vue&type=script&lang=js"
export * from "./ModalSelectDoctors.vue?vue&type=script&lang=js"
import style0 from "./ModalSelectDoctors.vue?vue&type=style&index=0&id=4b86de72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b86de72",
  null
  
)

export default component.exports